import { tealiumEventPageTypes, PageNames, SegmentSources } from '@foxcorp/delta-web-analytics';
import { getShowType } from 'helpers/ContentHelper';
import { getItemBadge } from 'helpers/VideoProcessorHelper';

const getShowPanelProps = ({ item }) => {
  const posterImage = item?.images?.['dcg-mark-poster']?.raw;
  const posterAltText = item?.images?.['dcg-mark-poster']?.altText ?? '';
  const link = `/${item?.showCode}`;
  const type = item?.['@type'];
  const id = item?.id;

  return {
    posterImage,
    posterAltText,
    link,
    overlayProps: {
      badge: getItemBadge({item}),
      favoriteData: {
        actionLocation: 'playlist',
        favoritableItems: [{ '@type': type, id }],
        favoriteType: 'personality',
        location: tealiumEventPageTypes?.[PageNames.HOME],
        networkId: item?.network,
        recommendationId: item?.trackingData?.properties.recommendationId ?? '',
        seriesName: item?.name,
        showID: item?.showCode,
        showType: getShowType({ videoType: item?.videoType, seriesType: item?.seriesType }),
        source: SegmentSources.DETAIL,
      },
      isPersonality: true,
    },
  };
};

export default getShowPanelProps;
